import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOrderGetAvailableStatusesQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OrderStatusType } from 'api/types/entity/order/orderStatusType';
import { lodash } from 'helpers';

export const useOrderGetAvailableStatuses = (orderId: string) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOrderGetAvailableStatusesQuery({
    variables: { id: orderId },
  });

  const error = useError(apolloError);

  const availableStatuses = useMemo(() => {
    if (!data?.availableStatuses) return [];
    return lodash.compact(data.availableStatuses).map((status) => ({
      status: OrderStatusType[status.status],
      isRequiredClosedDate: status.isRequiredClosedDate,
      isRequiredFmNumber: status.isRequiredFmNumber,
      isRequiredReason: status.isRequiredReason,
    }));
  }, [data?.availableStatuses]);

  return {
    availableStatuses,
    loading,
    error,
  };
};
